import { css } from '@emotion/react';
import { ProColors } from '@treatwell/treatwell-aura';
import { ReactNode } from 'react';

type PromptProps = {
  text: ReactNode;
};

export function Prompt(props: PromptProps): JSX.Element {
  return (
    <div
      className="aura--copy-normal"
      css={css({ color: ProColors.navy[800], fontWeight: 400 })}
    >
      {props.text}
    </div>
  );
}
